<div id="main">
  <div id="upper">
    @if (!hideWidgetBar()) {
      <jmkw-widget-bar
        [activeWidgetMap]="activeWidgetMap()"
        >
      </jmkw-widget-bar>
    }
    <jmkw-map-view
      (mapLoaded)="mapLoadedEvent($event)"
      (viewsLoaded)="viewsLoadedEvent($event)"
      (layersLoaded)="layersLoadedEvent($event)"
      >
    </jmkw-map-view>
    @if (!hideToolbar()) {
      <jmkw-toolbar [buttonMap]="buttonMap()">
      </jmkw-toolbar>
    }
  </div>
  <jmkw-legends></jmkw-legends>
</div>
